<div class="filters">
  <p class="filters__label">Filters</p>
  <div class="filters__list">
    @for (filter of filtersArray.controls; let index = $index; track filter.get('id')?.value) {
      <app-filter-item
        [filterGroup]="filter"
        [preselectedFilter]="getFilterBy(filter.get('id')?.value)"
        [treeNodes]="treeNodes"
        [type]="type"
        (filterDeleted)="deleteFilter(index)"></app-filter-item>
    } @empty {
      <div class="filters__list--empty">No filters added yet</div>
    }
  </div>
  <button class="filters__add-new" mat-stroked-button (click)="addNewFilter()">Add Filter</button>
</div>
